
import { RevCardCarousel } from '@ds/components/CardCarousel'
import isEmpty from 'lodash/isEmpty'

import BuyingGuideCard from '@buying-guide/components/Card'

import BlockTitle from '../private/BlockTitle'

import translations from './BuyingGuides.translations'

export default {
  components: {
    BlockTitle,
    BuyingGuideCard,
    RevCardCarousel,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    guides: {
      type: Array,
      default: () => [],
    },
    subtitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tracking: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    translations: () => translations,
    hasGuides() {
      return !isEmpty(this.guides)
    },
  },
  methods: {
    trackingDataByCard({ tagline, title }) {
      return {
        ...this.tracking,
        name: title,
        value: {
          type: this.tracking.value,
          articleCategory: tagline,
        },
      }
    },
  },
}
